import styled from "styled-components"

export const Title = styled.h1``
export const SubTitle = styled.h2``
export const SubTitleBold = styled.h2``
export const SubHeading = styled.h2``
export const Text = styled.p`
  text-align: left;
  overflow-wrap: anywhere;
`
export const Bold = styled.strong`
  font-weight: bold;
`
export const Label = styled.label`
  display: block;
  margin-top: 1rem;
`
export const LabelToo = styled.label`
  display: block;
  margin: 1rem 0 0.25rem;
`
export const Divider = styled.div``

export const IconLabel = styled.div``
export const ButtonNoStyle = styled.button`
  min-height: 44px;
  min-width: 44px;
  background-color: rgba(0, 0, 0, 0);
  border: none;
`
export const Link = styled.a`
  overflow-wrap: anywhere;
`
